
export const initGlobal = () => {
  /**
   * Give Text-Image-block specific styling if the first article-element on the page.
   */
  const container = document.querySelector('.page-content');
  const articleElements = container.querySelectorAll('article');

  if (articleElements.length > 0 && articleElements[0].classList.contains('text-image-block')) {
    articleElements[0].classList.add('text-image-block--text-align-left');
  }
}